module.exports = __webpack_public_path__ + "img/email.43046cb5.svg";